/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 提交订单发票
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  confirmInfo: order.InvoiceConfirmReq,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: order.InvoiceConfirmInfo;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/order/order-invoice`,
    data: confirmInfo,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
